import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Componente per gestire gli aggiornamenti automatici del Service Worker.
 * Con registerType: 'autoUpdate', il nuovo SW si attiva automaticamente.
 * Questo componente ascolta quando il nuovo SW prende controllo e ricarica
 * la pagina UNA SOLA VOLTA per applicare gli aggiornamenti.
 */
export const UpdatePrompt: React.FC = () => {
  useRegisterSW({
    onRegistered(registration) {
      console.log('✅ Service Worker registrato');

      // Controlla aggiornamenti ogni ora
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // 1 ora
      }
    },
    onRegisterError(error) {
      console.error('❌ Errore registrazione Service Worker:', error);
    },
  });

  useEffect(() => {
    // Ascolta quando un nuovo Service Worker prende controllo
    const handleControllerChange = () => {
      // Controlla se abbiamo già ricaricato per questo aggiornamento
      const hasReloaded = sessionStorage.getItem('sw-reloaded');

      if (!hasReloaded) {
        console.log('🔄 Nuovo Service Worker attivo, ricarico la pagina...');
        // Marca che stiamo ricaricando (sessionStorage si pulisce alla chiusura tab)
        sessionStorage.setItem('sw-reloaded', 'true');
        // Ricarica la pagina per applicare gli aggiornamenti
        window.location.reload();
      }
    };

    // Registra l'evento
    navigator.serviceWorker?.addEventListener('controllerchange', handleControllerChange);

    // Cleanup
    return () => {
      navigator.serviceWorker?.removeEventListener('controllerchange', handleControllerChange);
    };
  }, []);

  // Pulisci il flag quando la pagina è completamente caricata
  useEffect(() => {
    sessionStorage.removeItem('sw-reloaded');
  }, []);

  // Non renderizza nulla - tutto avviene in background
  return null;
};
